// Dependencies
import React from 'react';
import { ThemeContext } from '../../../components/theme/Theme.jsx';
import radium from 'radium';
import { connect } from 'react-redux';
import { updateAmountOfTickets } from '../../../redux/eventPageReducer';
import { refreshEvent } from '../../../redux/eventReducer';

// Styles
import './Pricelevel.scss';
import LeoSelect from "../../../components/form/LeoReactSelect";
import LeoLabel from "../../../components/form/LeoLabel";

function Pricelevel(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		priceLevel: {
			margin: context.themeManager.value('event-price-level-item', 'margin'),
		},
		ticketPrice: {
			color: context.themeManager.value('event-ticket-price', 'color'),
			fontWeight: context.themeManager.value('event-ticket-price', 'fontWeight'),
		},
	};

	const amountOfTicketsConfig = context.themeManager.getIntOrNullFromTheme('pricelevel', 'amount-of-tickets', null) || 10;
	const limits = [parseInt(amountOfTicketsConfig, 10), parseInt(props.ticketsAvailable, 10)];
	if (props.pricelevel.maxAllowed) {
		limits.push(parseInt(props.pricelevel.maxAllowed, 10));
	}
	const numberOfTicketDropdownOptions = Math.min(...limits);
	const options = [];
	for (let i = 1; i <= numberOfTicketDropdownOptions; i++) {
		options.push(i);
	}

	let selectOptions =  options.map((i) => {
		return {
			value: i,
			label: i.toString(),
			isSelected: i === props.amountOfTickets,
		}
	})
	selectOptions.unshift({value: 0, label: 'Anzahl', isSelected: props.amountOfTickets === 0})

	const { amountOfTickets, onChange, pricelevel } = props;
	React.useEffect(() => {
		if (pricelevel && numberOfTicketDropdownOptions > 0 && amountOfTickets > numberOfTicketDropdownOptions) {
			onChange({
				target: {
					value: numberOfTicketDropdownOptions
				}
			});
		}
	}, [amountOfTickets, numberOfTicketDropdownOptions, onChange, pricelevel]);

	return props.pricelevel ?
		(
			<div className="pricelevel__item" style={style.priceLevel}>
				<div className="pricelevel__name" id={`pl-name_` + props.pricelevel.priceLevelUuid}>
					{props.pricelevel.name}
				</div>
				<div className="pricelevel__value">
					je {parseFloat(props.pricelevel.price.value).toFixed(2)} €
				</div>
				<div className="pricelevel__amount">
					<LeoLabel className={"visually-hidden"} id={'pl_label_' + props.pricelevel.priceLevelUuid} for={'pl_' + props.pricelevel.priceLevelUuid} label={`Anzahl Tickets Preisstufe ${props.pricelevel.name}`}/>
					<LeoSelect
						key={props.pricelevel.priceLevelUuid}
						placeholder={"Anzahl"}
						id={'pl_' + props.pricelevel.priceLevelUuid}
						className="dropdown"
						onChange={props.onChange}
						value={props.amountOfTickets}
						name={`Anzahl Tickets Preisstufe ${props.pricelevel.name}`}
						options={selectOptions}
						centerText={true}
						smallDropdown={true}
					>
					</LeoSelect>
					{props.pricelevel.maxAllowed &&
						<div className="pricelevel__limit-hint">
							max. {props.pricelevel.maxAllowed}
						</div>
					}
				</div>
				<div className="pricelevel__price--total" style={style.ticketPrice}>
					{parseFloat(props.totalPrice).toFixed(2)} €
				</div>
			</div>
		) : (null);
}

const RadiumPricelevel = radium(Pricelevel);


// ------------------------------
// Store Connection
// ------------------------------
const mapStateToProps = (state, ownProps) => {
	const amountOfTickets = state.eventPage.amountOfTickets[ownProps.pricelevel.priceLevelUuid] || 0;
	return {
		categoryUuid: ownProps.categoryUuid,
		pricelevel: ownProps.pricelevel,
		totalPrice: amountOfTickets * ownProps.pricelevel.price.value,
		amountOfTickets,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	onChange: async (event) => {
		const amount = parseInt(event.target.value, 10);
		const cUuid = ownProps.categoryUuid;
		const pUuid = ownProps.pricelevel.priceLevelUuid;
		await dispatch(updateAmountOfTickets(cUuid, pUuid, amount));
		dispatch(refreshEvent());
	},
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(RadiumPricelevel);
